module.exports = __webpack_public_path__ + "static/media/md-aperture.189866de.svg";